import React, {Component} from 'react'
import PropTypes from 'prop-types'
import timeHumanize from "../../../helpers/timeHumanize"

class DateCreated extends Component {
    render() {
        const {createdAt} = this.props

        return (
            <td className="DateCreated">
                {timeHumanize(createdAt)}
            </td>
        )
    }
}

DateCreated.propTypes = {
    createdAt: PropTypes.string
}

export default DateCreated